import gql from 'graphql-tag'

import { UserFieldsFragment } from './user'

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($user: UpdateUserParams!) {
    updateUser(user: $user) {
      ...UserFields
    }
  }

  ${UserFieldsFragment}
`
